import { render, staticRenderFns } from "./importDetail.vue?vue&type=template&id=c8f4fd90&scoped=true&"
import script from "./importDetail.vue?vue&type=script&lang=js&"
export * from "./importDetail.vue?vue&type=script&lang=js&"
import style0 from "./importDetail.vue?vue&type=style&index=0&id=c8f4fd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4fd90",
  null
  
)

export default component.exports